import React, { useEffect, useState } from "react";
import { useDocTitle } from "../../components/_common/DocTitle";
import { useTranslation } from "react-i18next";
import clsx from 'clsx'

import { Grid, Typography, List, ListItem, ListItemText, ListItemIcon } from "@material-ui/core";
import { MenuBook, BlurOnOutlined } from '@material-ui/icons'
import { makeStyles } from "@material-ui/styles";

import axios from 'axios';
import APIs from "../../APIs";

const Preloader = React.lazy(() => import('../../components/_common/Preloader'))

const regex = /(<([^>]+)>)|\t|\n|&nbsp;/gi

const useStyles = makeStyles((theme) => ({
    bigTitle: {
        margin: theme.spacing(0, 4, 4, 4),
        textAlign: "center",
        justifyContent: "center",
        [theme.breakpoints.down('sm')]: {
            fontSize: '1.125rem',
            fontWeight: theme.typography.fontWeightMedium
        },
    },
    name: {
        fontSize: '1.5rem',
        margin: theme.spacing(8, 2, 8, 2),
        textAlign: "center",
        fontWeight: theme.typography.fontWeightBold,
        [theme.breakpoints.down('sm')]: {
            fontSize: '1rem',
            margin: theme.spacing(4, 1, 2, 1),
        },
    },
    title: {
        fontWeight: theme.typography.fontWeightBold,
        [theme.breakpoints.down('sm')]: {
            fontSize: '0.75rem',
        },
    },
    text: {
        [theme.breakpoints.down('sm')]: {
            fontSize: '0.75rem',
            paddingLeft: theme.spacing(2)
        },
    },
    topMargin: {
        marginTop: theme.spacing(6),
        [theme.breakpoints.down('sm')]: {
            marginTop: theme.spacing(3),
        }
    },
    inlineFlex: {
        display: 'inline-flex'
    }
}))

const RSIGESTORZY_InfoPage = props => {
    const classes = useStyles();
    const { t } = useTranslation();
    useDocTitle(t('pages.issuers'));

    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true)

    useEffect(() => {
        data ||
            axios
                .get(`${APIs.dataURL.rsisystemy}/${props.match.params.id}`)
                // .get('./devData/s1374.json')
                .then(result => {
                    const apiData = result.data//.results.map(item => ({ ...item, nazwa_systemu: item.nazwa_systemu.replace(/(<([^>]+)>)|\t|\n/gi, "") }));

                    setData(apiData)
                })
                .catch(error => {
                    console.log(error)
                })
                .finally(() => {
                    setLoading(false)
                })
    }, 
    // eslint-disable-next-line
    [data])

    const [isMobile, setIsMobile] = useState(window.innerWidth < 599.95);
    useEffect(() => {
        window.addEventListener('resize', () => {
            setIsMobile(window.innerWidth < 599.96)
        });
    }, [isMobile])

    return (
        <>
            <Typography variant="h4" className={classes.bigTitle} color="primary">{t('pages.systems')}</Typography>
            <Typography variant="h4" className={classes.bigTitle} color="primary">{t('pages.infopage')}</Typography>
            {
                loading
                    ? <Preloader />
                    : <>
                        <Typography variant={"h5"} className={classes.name}>
                            {data.nazwa_systemu ? data.nazwa_systemu.replace(regex, "") : ''}
                        </Typography>
                        <Grid container >
                            <Grid item xs={12} md>
                                <Typography variant={"body2"} className={classes.title}>
                                    {t('Nazwa skrócona')}{':'}
                                </Typography>
                                <Typography variant={"body2"} className={classes.text}>
                                    {data.nazwa_systemu_skr ? data.nazwa_systemu_skr.replace(regex, "") : ''}
                                </Typography>
                            </Grid>
                            <Grid item xs={12} md={5}>
                                <Typography variant={"body2"} className={classes.title}>
                                    {t('Gestor')}{':'}
                                </Typography>
                                <Typography variant={"body2"} className={classes.text}>
                                    {/* {data.gestor ? data.gestor.replace(regex, "") : ''} */}
                                    {data.gestor ? data.gestor.replace(regex, "") : ''}
                                </Typography>
                            </Grid>
                            <Grid item xs={12} md>
                                <Typography variant={"body2"} className={classes.title}>
                                    {t('Sposób prowadzenia')}{':'}
                                </Typography>
                                <Typography variant={"body2"} className={classes.text}>
                                    {/* {data.sposob_prowadzenia_systemu ? data.sposob_prowadzenia_systemu.replace(regex, "") : ''} */}
                                    {data.sposob_prowadzenia_systemu ? data.sposob_prowadzenia_systemu.replace(regex, "") : ''}
                                    {/* {data.poziom_gromadzenia_danych ? ', ' + data.poziom_gromadzenia_danych.replace(regex, "") : ''} */}
                                    {data.poziom_gromadzenia_danych ? ', ' + data.poziom_gromadzenia_danych.replace(regex, "") : ''}
                                </Typography>
                            </Grid>
                            <Grid item xs={12} md>
                                <Typography variant={"body2"} className={classes.title}>
                                    {t('Zasięg')}{':'}
                                </Typography>
                                <Typography variant={"body2"} className={classes.text}>
                                    {data.czy_krajowy && t('krajowy')}
                                    {data.czy_lokalny && t('lokalny')}
                                    {/* {!data.czy_krajowy && !data.czy_lokalny && ''} */}
                                </Typography>
                            </Grid>
                        </Grid>
                        {
                            data.aktyprawne && data.aktyprawne.length &&
                            <Grid container className={classes.topMargin}>
                                <Grid item xs={12}>
                                    <Typography variant={"body2"} className={classes.title}>
                                        {t('Podstawa prawna')}{':'}
                                    </Typography>
                                </Grid>
                                <Grid item xs={12}>
                                    {
                                        data.aktyprawne.map(akt => {
                                            return (
                                                <List dense style={{ padding: 0 }} key={akt.id_akt}>
                                                    <ListItem
                                                        alignItems={'flex-start'}
                                                        style={{ paddingTop: 0, paddingBottom: 0 }}
                                                    >
                                                        <ListItemIcon style={{ minWidth: 40 }}>
                                                            <MenuBook fontSize={'small'} />
                                                        </ListItemIcon>
                                                        <ListItemText
                                                            disableTypography
                                                            primary={
                                                                <Typography variant={"body2"} className={classes.text}>
                                                                    {akt.nazwa ? akt.nazwa.replace(regex, "") : ''}
                                                                </Typography>
                                                            }
                                                            secondary={
                                                                <Typography variant={"body2"} className={classes.text}>
                                                                    <small><b><em>{t('Miejsce publikacji')}{':'}&nbsp;&nbsp;</em></b>{akt.miejsce_publikacji}</small>
                                                                </Typography>
                                                            }
                                                            classes={{ primary: classes.text, secondary: classes.text }}
                                                        />
                                                    </ListItem>
                                                </List>
                                            )
                                        })
                                    }

                                </Grid>
                            </Grid>
                        }
                        {
                            data.cel_systemu &&
                            <Grid container className={classes.topMargin} >
                                <Grid item xs={12} md={12}>
                                    <Typography variant={"body2"} className={classes.title}>
                                        {t('Cel systemu')}{':'}
                                    </Typography>
                                    <Typography variant={"body2"} className={classes.text}>
                                        {data.cel_systemu?data.cel_systemu.replace(regex, ""):''}
                                    </Typography>
                                </Grid>
                            </Grid>
                        }
                        {
                            data.zrodla_danych_czestotliwosc_aktualizacji &&
                            <Grid container className={classes.topMargin} >
                                <Grid item xs={12} md={12}>
                                    <Typography variant={"body2"} className={classes.title}>
                                        {t('Źródła i częstotliwość aktualizacji')}{':'}
                                    </Typography>
                                    <Typography variant={"body2"} className={classes.text}>
                                       <div dangerouslySetInnerHTML={data.zrodla_danych_czestotliwosc_aktualizacji.replace(regex, "")}/>
                                    </Typography>
                                </Grid>
                            </Grid>
                        }
                        {
                            data.termin_formy_udostepniania_danych &&
                            <Grid container className={classes.topMargin} >
                                <Grid item xs={12} md={12}>
                                    <Typography variant={"body2"} className={classes.title}>
                                        {t('Terminy i formy udostępniania')}{':'}
                                    </Typography>
                                    <Typography variant={"body2"} className={classes.text}>
                                        {data.termin_formy_udostepniania_danych.replace(regex, "")}
                                    </Typography>
                                </Grid>
                            </Grid>
                        }
                        {
                            data.obiekty && data.obiekty.length &&
                            <Grid container className={classes.topMargin}>
                                <Grid item xs={12}>
                                    <Typography variant={"body2"} className={classes.title}>
                                        {t('Obiekty opisywane w systemie')}{':'}
                                    </Typography>
                                </Grid>
                                <Grid item xs={12}>
                                    {
                                        data.obiekty.map(object => {
                                            return (
                                                <List dense style={{ padding: 0 }} key={object.id_obiektu}>
                                                    <ListItem style={{ paddingTop: 0, paddingBottom: 0 }}>
                                                        <ListItemText
                                                            disableTypography
                                                            primary={
                                                                <>
                                                                    <Typography variant={"body2"} className={clsx(classes.title, classes.inlineFlex)}>
                                                                        {t('Typy')}{':'} &nbsp;
                                                                </Typography>
                                                                    <Typography variant={"body2"} className={clsx(classes.text, classes.inlineFlex)}>
                                                                        {object.typ_obiektu ? object.typ_obiektu.replace(regex, "") : ''}
                                                                    </Typography>
                                                                </>
                                                            }
                                                            classes={{ primary: classes.text, secondary: classes.text }}
                                                        />
                                                    </ListItem>

                                                    <ListItem style={{ paddingTop: 0, paddingBottom: 0 }}>
                                                        <ListItemText
                                                            disableTypography
                                                            primary={
                                                                <>
                                                                    <Typography variant={"body2"} className={clsx(classes.title, classes.inlineFlex)}>
                                                                        {t('Nazwa')}{':'} &nbsp;
                                                                    </Typography>
                                                                    <Typography variant={"body2"} className={clsx(classes.text, classes.inlineFlex)}>
                                                                        {object.nazwa_obiektu ? object.nazwa_obiektu.replace(regex, "") : ''}
                                                                    </Typography>
                                                                </>
                                                            }
                                                            classes={{ primary: classes.text, secondary: classes.text }}
                                                        />
                                                    </ListItem>

                                                    <ListItem style={{ paddingTop: 0, paddingBottom: 0 }}>
                                                        <ListItemText
                                                            disableTypography
                                                            primary={
                                                                <>
                                                                    <Typography variant={"body2"} className={clsx(classes.title, classes.inlineFlex)}>
                                                                        {t('Opis')}{':'} &nbsp;
                                                                        </Typography>
                                                                    <Typography variant={"body2"} className={clsx(classes.text, classes.inlineFlex)}>
                                                                        {object.opis_obiektu ? object.opis_obiektu.replace(regex, "") : ''}
                                                                    </Typography>
                                                                </>
                                                            }
                                                            classes={{ primary: classes.text, secondary: classes.text }}
                                                        />
                                                    </ListItem>
                                                    {
                                                        object.cechyobiektu && object.cechyobiektu.length &&
                                                        <List dense style={{ padding: 0 }}>
                                                            <ListItem style={{ paddingTop: 0, paddingBottom: 0 }}>
                                                                <ListItemText
                                                                    disableTypography
                                                                    primary={
                                                                        <Typography variant={"body2"} className={classes.title}>
                                                                            {t('Cechy informacyjne opisujące obiekt')}{':'}
                                                                        </Typography>
                                                                    }
                                                                    classes={{ primary: classes.text, secondary: classes.text }}
                                                                />
                                                            </ListItem>
                                                            {object.cechyobiektu.map(cecha => {
                                                                return (
                                                                    <ListItem
                                                                        alignItems={'flex-start'}
                                                                        style={{ paddingTop: 0, paddingBottom: 0 }}
                                                                        key={cecha.id_cechy}
                                                                    >
                                                                        <ListItemIcon style={{ minWidth: 32 }}>
                                                                            <BlurOnOutlined fontSize={'small'} />
                                                                        </ListItemIcon>
                                                                        <ListItemText
                                                                            disableTypography
                                                                            primary={
                                                                                <Typography variant={"body2"} className={classes.text}>
                                                                                    {cecha.nazwa_cechy?cecha.nazwa_cechy.replace(regex, ""):''}
                                                                                </Typography>
                                                                            }
                                                                            classes={{ primary: classes.text, secondary: classes.text }}
                                                                            secondary={
                                                                                cecha.aktyprawne && cecha.aktyprawne.length

                                                                                    ? <Grid container>
                                                                                        <Grid item xs={12}>
                                                                                            <Typography variant={"body2"} className={classes.title}>
                                                                                                <small>{t('Podstawa prawna')}{':'}</small>
                                                                                            </Typography>
                                                                                        </Grid>
                                                                                        <Grid item xs={12}>
                                                                                            {
                                                                                                cecha.aktyprawne.map(akt => {
                                                                                                    return (
                                                                                                        <List dense style={{ padding: 0 }} key={akt.id_akt}>
                                                                                                            <ListItem
                                                                                                                alignItems={'flex-start'}
                                                                                                                style={{ paddingTop: 0, paddingBottom: 0 }}
                                                                                                            >
                                                                                                                <ListItemIcon style={{ minWidth: 40 }}>
                                                                                                                    <MenuBook fontSize={'small'} />
                                                                                                                </ListItemIcon>
                                                                                                                <ListItemText
                                                                                                                    disableTypography
                                                                                                                    primary={
                                                                                                                        <Typography variant={"body2"} className={classes.text}>
                                                                                                                            <small>
                                                                                                                                {akt.nazwa ? akt.nazwa.replace(regex, "") : ''}
                                                                                                                            </small>
                                                                                                                        </Typography>
                                                                                                                    }
                                                                                                                    secondary={
                                                                                                                        <Typography variant={"body2"} className={classes.text}>
                                                                                                                            <small>
                                                                                                                                <small>
                                                                                                                                    <b><em>
                                                                                                                                        {t('Miejsce publikacji')}{':'}&nbsp;&nbsp;
                                                                                                                                        </em></b>
                                                                                                                                    {akt.miejsce_publikacji}
                                                                                                                                </small>
                                                                                                                            </small>
                                                                                                                        </Typography>
                                                                                                                    }
                                                                                                                    classes={{ primary: classes.text, secondary: classes.text }}
                                                                                                                />
                                                                                                            </ListItem>
                                                                                                        </List>
                                                                                                    )
                                                                                                })
                                                                                            }

                                                                                        </Grid>
                                                                                    </Grid>
                                                                                    : ''
                                                                            }
                                                                        />


                                                                    </ListItem>
                                                                )
                                                            })}
                                                        </List>
                                                    }
                                                </List>

                                            )
                                        })
                                    }

                                </Grid>

                            </Grid>
                        }
                    </>
            }
        </>
    )
}

export default RSIGESTORZY_InfoPage
